//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';

import Button from '@material-ui/core/Button';
//Material-ui

//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';


import PartPageTitle from './PartPageTitle';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      enable: false,
      enableError: null,
      newName: this.props.my.profile.userdata_name,
      newNameError: null,
      newNameSaveDialog: false,
      saveSnackVisible: false,
    }
	}

  componentDidMount() {
    document.title = 'ハンドルネームの変更 - パートナーズ';
    this._newNameEditCheck();
  }

  _newNameEditCheck() {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    return axios.post(config.apiUri + "member/settingNameEditCheck.php", params, {
      timeout: 10000
    })
    .then((res) => {
      if (res.data.bool) {
        this.setState({ enable: true});
      }
      else {
        this.setState({ enable: false});
        this.setState({ enableError: res.data.comment });
      }
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }

  _newNameEdit(value) {
    this.setState({ newName: value});
    let errorComment;

    if (value.length < 2 || value.length > 8) {
  		errorComment = '2～8文字で入力してください';
  	}
  	else if (value.match(/^[ぁ-んァ-ヶa-zａ-ｚA-ZＡ-Ｚ一-龠0-9０-９ー～_-]+$/) == null) {
  		errorComment = '入力できない文字が含まれています';
  	}
  	if (errorComment) {
  		this.setState({newNameError: errorComment});
  	}
  	else {
      this.setState({newNameError: null});
    }
  }

  async _newNameSaveCheck() {
    await this._newNameEdit(this.state.newName);
    if (this.state.newNameError === null) {
      this.setState({newNameSaveDialog: true});
    }
  }

  _newNameSaveSubmit() {
    this.props.settingNameEdit(this.state.newName, () => {
      this.setState({newNameSaveDialog: false});
      this._newNameEditCheck();
    });
  }

  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'ニックネームの変更'}
          onback={ '/setting/' }
        />

        <div style={{maxWidth:'400px', margin:'auto'}}>
          {
            (this.state.enable) ?
            <div>
              <div style={{padding:'10px'}}>

                <ul style={{paddingLeft:'20px'}}>
                  <li>変更するとメールボックスやお気に入りなど表示されるすべてのニックネームが変更されます。</li>
                  <li>ニックネームのみ変更ですので再登録のアカウントにはなりません。</li>
                  <li>変更後は100日再変更できません。</li>
                </ul>


                <div style={{padding:'10px'}}>
                  <h3 align='center'>新しいニックネームを入力してください</h3>
                  ひら・カナ・漢字・英・数 2～8文字
                  <input
                    type="text"
                    value={ this.state.newName }
                    style={{fontSize:'1.2em'}}
                    className="input_blue round12"
                    onChange={ (e) => this._newNameEdit(e.target.value) }
                  />
                  <div style={{color:'red'}}>{this.state.newNameError}</div>
                </div>
              </div>

              <div align='center' style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{minWidth:'240px'}}
                  onClick={ () => this._newNameSaveCheck() }
                  disabled={ ((this.state.newName) && (this.state.newName !== this.props.my.profile.userdata_name) && (!this.state.newNameError)) ? false : true }
                >
                  <span style={{fontSize:'1.4em'}}>変更する</span>
                </Button>
              </div>
            </div>:
            <div>
              <div>{this.state.enableError}</div>
            </div>
          }
        </div>
        <DialogConfirm
          open={ this.state.newNameSaveDialog }
          title={'ハンドルネームの変更'}
          content={(
            <div>
              <div>ハンドルネームを「{this.state.newName}」に変更してもいいですか？</div>
              <div style={{color:'red'}}>※変更後は100日再変更できません</div>
            </div>
          )}
          apply={ () => this._newNameSaveSubmit() }
          close={ () => this.setState({newNameSaveDialog: false}) }
        />

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
